<template>
  <div>
    <v-main>
      <v-container fluid>
        <v-card id="titlecard" flat>
          <v-row cols="12" dense>
            <v-col cols="12">
              <h2>{{ this.title }}</h2>
              <h5 class="subtitle-weight">(Nr. of complaints in selection: {{ this.filteredClaims.length }})</h5>
            </v-col>
          </v-row>
          <v-row dense cols="12">
            <v-col cols="2">
              <v-text-field v-model="search" clearable prepend-icon="mdi-magnify" label="Search through all fields"
                single-line hide-detail />
            </v-col>
            <v-col cols="2" v-if="params[0] != 'user'" class="pl-4">
              <select_gebr :selected_gebr="selected_gebr" field="selected_gebr" label="Assigned to" :isDense="false"
                :isClearable="true" @updateData="updateData" />
            </v-col>
            <v-col cols="3" class="pl-4">
              <filter_eventstatus :selected_stats="selected_klst" label="Status" field="selected_klst"
                :isClearable="true" @updateData="updateData" ref="cbo_eventstatus" />
            </v-col>
            <v-col cols="3" class="pl-4">
              <filter_causes :selected_causes="selected_kloz" label="Cause(s)" field="selected_kloz" :isClearable="true"
                @updateData="updateData" />
            </v-col>
            <v-col cols="1" class="pl-4">
              <input_amount label="Claimed (total)" prefix="€" :isDense="false" :isReadOnly="true"
                :amount="claimed_display" field="claimed_display" />
            </v-col>
            <v-col cols="1" class="pl-8 pt-6">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-spacer />
                  <v-icon v-bind="attrs" v-on="on" medium color="green"
                    v-on:click="exportDataToExcel()">mdi-microsoft-excel</v-icon>
                </template>
                <span>Export data to Excel</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row dense cols="12">
            <v-col cols="1">
              <date_picker label="Arrival from" icon="mdi-calendar" :date="arrivalDateFromISO"
                field="arrivalDateFromISO" @updateData="updateData" />
            </v-col>
            <v-col cols="1">
              <date_picker label="Arrival until" icon="mdi-calendar" :date="arrivalDateUntilISO"
                field="arrivalDateUntilISO" @updateData="updateData" />
            </v-col>
            <v-col cols="2" class="pl-4">
              <select_slot :selected_slot="selected_slot" field="selected_slot" label="Timing" :isDense="true"
                :isClearable="true" @updateData="updateData" />
            </v-col>
            <v-col cols="3" class="pl-4">
              <filter_booking_type :booking_type="booking_type" label="Booking Type" field="booking_type"
                :isClearable="true" @updateData="updateData" />
            </v-col>
          </v-row>
        </v-card>
        <v-row class="row-default">
          <v-col cols="12" class="px-2">
            <v-data-table id="x" dense :headers="getHoklHeaders()" :items="filteredClaims" :disable-pagination=true
              hide-default-footer item-key="activity" :loading="loading" loading-text="Loading data...please wait"
              fixed-header :search="search" :height="wInnerHeight">
              <template v-slot:header.attachments>
                <v-icon small>mdi-paperclip</v-icon>
              </template>
              <template v-slot:header.sort>
                <v-icon small>mdi-flag-variant-outline</v-icon>
              </template>
              <template v-slot:item="claim">
                <tr>
                  <td class="td_markup">
                    <table>
                      <tr>
                        <td class="row-pointer booking-color">
                          <span v-on:click="$router.open('/huov/onHuov/' + claim.item.huov_encrid)">{{
                            claim.item.booking }}</span>
                        </td>
                      </tr>
                      <tr v-if="claim.item.partner !== ''">
                        <td>
                          {{ claim.item.partner }}<template v-if="claim.item.partner === 'Airbnb'"> ({{ claim.item.partner_hostname }})</template>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="td_markup_xs">A: {{ claim.item.arrival_dmy }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="td_markup_xs">D: {{ claim.item.departure_dmy }}</span>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td class="td_markup"><div v-if="claim.item.cttp_nr==='5'"><v-icon color="error" size="20">mdi-alpha-e-circle</v-icon></div></td>
                  <td class="td_markup">{{ $moment(claim.item.created).format("DD-MM-YYYY HH:mm") }}
                  </td>
                  <td class=" td_markup booking-color row-pointer" v-if="params[0] !== 'huis'">
                    <table>
                      <tr v-if="params[0] !== 'huis'">
                        <td><span v-on:click="$router.open('/huis/onHuis/' + claim.item.huis_encrid)">{{
                            claim.item.accommodation
                            }}</span></td>
                      </tr>
                    </table>
                  </td>
                  <td class="td_markup">{{ claim.item.assigned_displayname }}</td>
                  <td class="td_markup">
                    <v-tooltip bottom :max-width="400" offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          {{ claim.item.case_info && claim.item.case_info.length > 100 ? claim.item.case_info.substring(0, 100) + '...' : claim.item.case_info }}
                        </span>
                      </template>
                      <span>{{ claim.item.case_info }}</span>
                    </v-tooltip>
                  </td>
                  <td class="td_markup">
                    <v-tooltip bottom :max-width="400" offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          {{ claim.item.summary && claim.item.summary.length > 100 ? claim.item.summary.substring(0, 100) + '...' : claim.item.summary }}
                        </span>
                      </template>
                      <span>{{ claim.item.summary }}</span>
                    </v-tooltip>
                  </td>
                  <td class="td_markup">
                    <span v-for="cause, idx in claim.item.selected_kloz" :key="idx">
                      <div>{{ cause.description }}</div>
                    </span>
                  </td>
                  <td class="td_markup">{{ claim.item.timing.description }}</td>
                  <td class="td_markup">{{ $moment(claim.item.modified).format("DD-MM-YYYY HH:mm") }}</td>
                  <td class="td_markup" style="text-align:right">{{ claim.item.claimedAmount | nl_numberformat |
                    prefix_euro}}</td>
                  <td class="td_markup pb-2">
                    <table v-for="amount, idx in claim.item.compensation" :key=idx
                      style="border-collapse:collapse !important;">
                      <tr :class="{ 'border-xs': !(idx + 1 === (claim.item.compensation.length)) }">
                        <td
                          :class="{ 'td-markup-xs': true, 'td-code': true, 'border-xs': !(idx + 1 === (claim.item.compensation.length)) }">
                          {{ amount.type }}</td>
                        <td
                          :class="{ 'td-markup-xs': true, 'td-name': true, 'booking-color': true, 'row-pointer': true, 'border-xs': !(idx + 1 === (claim.item.compensation.length)) }">
                          <span v-if="amount.type === 'Guest'" v-on:click="$router.open('/klnt/onKlnt/' + amount.encrid)">
                            {{ amount.name | max_char(25) }}
                          </span>
                          <span v-else v-on:click="$router.open('/eign/onEign/' + amount.encrid)">
                            {{ amount.name | max_char(25) }}
                          </span>
                        </td>
                        <td
                          :class="{ 'td-markup-xs': true, 'td-amount': true, 'border-xs': !(idx + 1 === (claim.item.compensation.length)) }">
                          {{ amount.amount | nl_numberformat }}</td>
                      </tr>
                    </table>
                  </td>
                  <td class="td_markup">{{ claim.item.hokl_klst_display }}</td>
                  <td class="td_markup" align="center">
                    <div v-if="!!claim.item.attachments">
                      {{ claim.item.attachments }}
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <div v-if="this.params[0] == 'all'">
      <navBar title="Ares - Customer Success" :home="true" type="customersuccess" goto="/task/customer_success/mnCustomerSuccess" />
    </div>
    <div v-else>
      <navBar title="Ares - Overview" :home="true" goto="/task/customer_success/mnCustomerSuccess" />
    </div>
    <!--  <div v-if="review.item.cttp_nr==='5'"><v-icon color="error">mdi-alpha-e-circle</v-icon></div> -->
  </div>
</template>

<script>

import select_gebr from '@/components/ui/selectors/select_gebr.vue'
import filter_eventstatus from '@/components/huov/hokl/ui/filter_eventstatus.vue'
import filter_causes from '@/components/huov/hokl/ui/filter_causes.vue'
import filter_booking_type from '@/components/huov/hokl/ui/filter_booking_type.vue'
import input_amount from '@/components/ui/input_amount.vue';
import date_picker from '@/components/ui/date_picker.vue';
import select_slot from '@/components/huov/hokl/ui/select_slot.vue'

import mxnumberformat from '@/mixins/amount_nl';
import mxmaxchar from '@/mixins/filtermaxchar';

import navBar from "@/components/ui/navbars/navbar.vue";


export default {
  props: ['param'],
  components: {
    navBar,
    select_gebr,
    filter_eventstatus,
    filter_causes,
    filter_booking_type,
    input_amount,
    date_picker,
    select_slot
  },
  data() {
    return {
      search: '',
      claims: [],
      loading: false,
      params: [],
      selected_gebr: null,
      selected_slot: null,
      selected_klst: [],
      selected_kloz: [],
      booking_type: [],
      incidentcauses: [],
      klct: [],
      kloz: [],
      bar_height: 0,
      card_height: 0,
      arrivalDateFromISO: null,
      arrivalDateUntilISO: null,
      wInnerHeight: window.innerHeight - 290, // deduct estimated height for toolbar, searchfield and headers
      title: 'Complaints overview',
      state: '',
      filter: '',
    }
  },
  created() { // set up event bus listener here on created event or get data

    window.addEventListener("resize", this.resizeEventHandler);

    if (this.param != null) {
      this.params = this.param.split(":");
    }
    this.getKlct();
    // this.getKloz(); misschien later
    this.getOverview();
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeEventHandler);
  },
  mounted() {
    console.log('param', this.param);
  },
  computed: {  // Dit is traaaaaaag....
    filteredClaims: function () {
      return this.claims.filter((claim) => {

        let matches_status = false;
        let matches_user = false;
        let matches_date_range = false;
        let matches_cause = false;
        let matches_slot = false;
        let matches_booking_type = false;

        // status
        if (this.selected_klst === null || this.selected_klst.length === 0) {
          matches_status = true;
        } else {
          for (let idx = 0; idx < this.selected_klst.length; idx++) {
            if (claim.hokl_klst === this.selected_klst[idx]) {
              matches_status = true;
              break;
            }
          }
        }
        if (this.selected_kloz === null || this.selected_kloz.length === 0 || claim.selected_kloz.length === 0) {
          matches_cause = true;
        } else {
          for (let indx = 0; indx < claim.selected_kloz.length; indx++) {
            for (let idx = 0; idx < this.selected_kloz.length; idx++) {
              if (claim.selected_kloz[indx].code === this.selected_kloz[idx]) {
                matches_cause = true;
                break;
              }
            }
          }
        }

        // user
        if (this.selected_gebr === null) {
          matches_user = true;
        } else {
          matches_user = claim.assigned.match(this.selected_gebr);
        }

        // slot
        if (this.selected_slot === null) {
          matches_slot = true;
        } else {
          matches_slot = claim.timing.code.match(this.selected_slot);
        }

        // booking type
        const today = this.$moment().startOf('day');
        const arrivalDate = this.$moment(claim.arrival).startOf('day');
        const departureDate = this.$moment(claim.departure).startOf('day');
        
        if (this.booking_type === null || this.booking_type.length === 0) {
          matches_booking_type = true;
        } else {
          for (let idx = 0; idx < this.booking_type.length; idx++) {
            const type = this.booking_type[idx];
            if (type === 'completed' && departureDate.isBefore(today)) {
              matches_booking_type = true;
              break;
            }
            if (type === 'ongoing' && arrivalDate.isSameOrBefore(today) && departureDate.isSameOrAfter(today)) {
              matches_booking_type = true;
              break;
            }
            if (type === 'upcoming' && arrivalDate.isAfter(today)) {
              matches_booking_type = true;
              break;
            }
          }
        }

        // dates
        if (this.arrivalDateFromISO === null && this.arrivalDateUntilISO === null) {
          matches_date_range = true;
        } else {
          if (claim.arrival <= this.arrivalDateUntilISO && this.arrivalDateFromISO === null) {
            matches_date_range = true;
          }
          if (claim.arrival >= this.arrivalDateFromISO && this.arrivalDateUntilISO === null) {
            matches_date_range = true;
          }
          if (this.arrivalDateFromISO > this.arrivalDateUntilISO) { // from date larger then until date = all dates are not valid    
            matches_date_range = false;
          }
          else {
            if (claim.arrival >= this.arrivalDateFromISO && claim.arrival <= this.arrivalDateUntilISO) {
              matches_date_range = true;
            }
          }
        }

        // result
        return matches_user && matches_status && matches_date_range && matches_cause && matches_slot && matches_booking_type;
      });
    },
    claimed: function () {
      var cnt = 0;
      var num;
      this.filteredClaims.forEach((claim) => {
        num = +claim.claimedAmount;
        cnt += num;
      })
      return parseFloat(cnt).toFixed(2);
    },
    // It's not possible to apply a filter on a v-model (like in a table definition). So we have to do it with a custom formatted computed value
    claimed_display: function () {
      return this.to_nl_numberformat(this.claimed);
    },
  },
  mixins: [mxnumberformat, mxmaxchar],
  methods: {
    updateData(data) {
      this[data.field] = data.value;
    },
    resizeEventHandler() {
      this.wInnerHeight = window.innerHeight - 290; // deduct estimated height for toolbar, searchfield and headers
    },
    getKlct() {
        this.$axios
            .post("ares/json/ares/huov/hokl/getKlct.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "getKlct"
                }
            })
            .then(res => {
                if (res.data.error) {
                    console.log(res.data.error);
                } else {
                    this.klct = res.data.getKlct;
                }
            });
    }, 
    getKloz() {
      this.$axios
        .post("ares/json/ares/huov/hokl/getKloz.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getKloz"
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.kloz = res.data.getKloz;
          }
        });
    },       
    getOverview() {
      this.loading = true;
      this.$axios
        .post("ares/json/ares/task/customer_success/hokl/getHoklOverviewV3.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHoklOverview"
          },
          getHoklOverview: {
            params: this.params,
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.claims = res.data.getHoklOverview;
            this.title += (' ' + res.data.header.entityvalue);
            this.state = res.data.header.state;
            this.filter = res.data.header.filter
            this.$refs.cbo_eventstatus.fixDropDown(this.state==='open')
          }
          this.loading = false;
        })
    },
    getHoklHeaders() {
      switch (this.params[0]) {
        case 'all':
        case 'klnt':
        case 'user':
        case 'eign':
          return [
            { text: "Booking/Arr/Dep", value: "booking", sortable: true, width: '8%' },
            { text: "Ctr", value: "cttp_nr", width: "4%", align: "center", sortable: true },
            { text: "Filed", value: "created", sortable: true, width: '6%' },
            { text: "Accom.", value: "accommodation", sortable: true, width: '5%' },
            { text: "Assigned", value: "assigned", sortable: true, width: '6%' },
            { text: "Case information", value: "case_info", sortable: false, width: '14%' },
            { text: "Latest development", value: "summary", sortable: false, width: '14%' },
            { text: "Cause", value: "selected_kloz", sortable: false, width: '7%' },
            { text: "Timing", value: "timing.description", sortable: true, width: '7%' },
            { text: "Updated", value: "modified", sortable: true, width: '6%' },
            { text: "Claimed", value: "claimedAmount", align: "end", sortable: false, width: '5.5%' },
            { text: "Compensation", value: "", sortable: false, width: '15%' },
            { text: "Stat", value: "hokl_klst_display", sortable: true, width: '8%' },
            { sortable: false, value: "attachments", align: "center", width: '1%' },
          ];
        case 'huis':
          return [
            { text: "Booking/Arr/Dep", value: "booking", sortable: true, width: '8%' },
            { text: "Ctr", value: "cttp_nr", width: "4%", align: "center", sortable: true },
            { text: "Filed", value: "created_dmy", sortable: true, width: '6%' },
            { text: "Assigned", value: "assigned", sortable: true, width: '6%' },
            { text: "Case information", value: "case_info", sortable: false, width: '14%' },
            { text: "Latest development", value: "summary", sortable: false, width: '14%' },
            { text: "Cause", value: "selected_kloz", sortable: false, width: '7%' },
            { text: "Timing", value: "timing.description", sortable: true, width: '7%' },
            { text: "Udated", value: "modified_dmy", sortable: true, width: '6%' },
            { text: "Claimed", value: "claimedAmount", align: "end", sortable: false, width: '5.5%' },
            { text: "Compensation", value: "", sortable: false, width: '15%' },
            { text: "Status", value: "hokl_klst_display", sortable: true, width: '8%' },
            { sortable: false, value: "attachments", align: "center", width: '1%' },
          ];

      }
    },
    exportDataToExcel() {

      let e_claims = [];
      let aGuest = 0;
      let aOwner = 0;
      let aCaretaker = 0;
      let aLeniency = 0;

      for (let t = 0; t < this.filteredClaims.length; t++) {

        let el = new Object();

        let causedby = '';
        this.filteredClaims[t].selected_kloz.forEach(obj => {
          if (causedby === '') {
            causedby = obj.description;
          } else {
            causedby += `, ${obj.description}`;
          }
        });

        el["Booking"] = this.filteredClaims[t].booking;
        el["Guest"] = this.filteredClaims[t].guest;
        el["Arrival"] = new Date(this.filteredClaims[t].arrival);
        el["Filed"] = new Date(this.filteredClaims[t].created);
        el["Accommodation"] = this.filteredClaims[t].accommodation;
        el["Owner"] = this.filteredClaims[t].owner_displayname;
        el["Agent"] = this.filteredClaims[t].rental_expert;
        el["Partner"] = this.filteredClaims[t].partner;
        el["Hostname"]=this.filteredClaims[t].partner_hostname;
        el["Acco Country"] = this.filteredClaims[t].acco_country;
        el["Guest Country"] = this.filteredClaims[t].guest_country;
        el["Assigned to"] = this.filteredClaims[t].assigned_displayname;

        this.klct.forEach(x => {
            const selectedKlct = this.filteredClaims[t].incident_type ?? '';            
            const selectedKlctArr = selectedKlct.split(',').map(s => s.trim()); // selectedKlct is a comma separated string, so split to array and trim spaces
            el[`${x.description}`] = selectedKlctArr.includes(x.description) ? '✔' : '';
        });


        el["Latest Development"] = this.filteredClaims[t].summary;
        el["Caused by"] = causedby;
        el["Timing"] = this.filteredClaims[t].timing.description;
        el["Modified"] = new Date(this.filteredClaims[t].modified); // formatted so it can be sorted as a date in Excel
        el["Status"] = this.filteredClaims[t].hokl_klst_display;
        el["Closed"] = +this.filteredClaims[t].num_closed_events;

        el["Comp. guest"] = 0;
        el["Comp. by owner (+ct)"] = 0;
        el["Comp. by caretaker"] = 0;
        el["Leniency VfY"] = 0;
        this.filteredClaims[t].compensation.forEach(obj => {
          switch (obj.role) {
            case 0:
              el["Comp. guest"] = obj.amount === '0' ? 0 : +obj.amount;
              break;
            case 10:
            case 12:
              el["Comp. by owner (+ct)"] = obj.amount === '0' ? 0 : +obj.amount;
              break;
            case 20:
              el["Comp. by caretaker"] = obj.amount === '0' ? 0 : +obj.amount;
              break;
          }
        });
        el["Leniency VfY"] = el["Comp. guest"] + el["Comp. by owner (+ct)"] + el["Comp. by caretaker"];
        el["Handling time"] = this.filteredClaims[t].handling_time;
        e_claims.push(el);

        aGuest += +el["Comp. guest"];
        aOwner += +el["Comp. by owner (+ct)"];
        aCaretaker += +el["Comp. by caretaker"];
        aLeniency += +el["Leniency VfY"];

      }

      var XLSX = require("xlsx");
      var ws = XLSX.utils.json_to_sheet(e_claims);
      var wb = XLSX.utils.book_new();

      // totals
      var cell = "AZ" + (e_claims.length + 3); // 1 = empty line, 1 = columnheaders, 1 is actual line we need to be (=3)
      // the prepended + sign makes sure that Excel understands it's a number. Passing it this way enables you to calculate with the values in Excel.
      XLSX.utils.sheet_add_aoa(ws, [["Totals", aGuest, aOwner, aCaretaker, aLeniency]], { origin: cell }); // we write starting from cell K + number value of cell

      XLSX.utils.book_append_sheet(wb, ws, "Complaints");
      XLSX.writeFile(wb, 'Complaints.xlsx');
    },
    listArrayElements(param) {
      return param.join();
    }
  }
}

</script>

<style scoped>
.row-pointer {
  cursor: pointer;
}

.row-default {
  cursor: default;
}

.booking-color {
  color: blue;
}

.no-booking-color {
  color: black;
}

.subtitle-weight {
  font-weight: 400;
}

.td_markup {
  vertical-align: top;
  border-top: 5px solid transparent;
  font-size: 12px !important
  /* trick to add padding to a TD element (which is not possible with CSS normally) */
}

.td-code {
  width: 7.5em;
}

.td-name {
  width: 8em;
}

.td-amount {
  width: 5em;
  text-align: end !important;
}

.td-markup-xs {
  padding-top: 1px;
  padding-bottom: 2px;
  vertical-align: top;
}

.border-xs {
  border-bottom: 1px solid lightgrey;
}
</style>